'use strict';

export default {
  devStoreConfig: false,
  api: {
    default: 'https://lit-coast-31020.herokuapp.com/v0',
  },
  features: {
    Ledger: false,
    BTC: false,
    BOT: false,
    Ebay: false,
    balanceSelling: false,
  }
};



// WEBPACK FOOTER //
// ./config/config.client11.js